import select from './UserSelect.vue'
const FormUserSelect = {
  install: function (Vue) {
    Vue.component('FormUserSelect', select)
  }
}
export default FormUserSelect
